"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var order = _interopRequireWildcard(require("@/api/order/food"));
var driver = _interopRequireWildcard(require("@/api/driver"));
var _date = require("@/utils/date");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _format = require("@/utils/format");
var _enum = require("@/utils/enum");
var _moment = _interopRequireDefault(require("moment"));
var _CustomerDialog = _interopRequireDefault(require("@/views/customer/components/CustomerDialog"));
var _DriverDialog = _interopRequireDefault(require("@/views/driver/components/DriverDialog"));
var _StoreDialog = _interopRequireDefault(require("@/views/store/components/StoreDialog"));
var _DetailFoodModal = _interopRequireDefault(require("./components/DetailFoodModal"));
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
var _ExportOrderModal = _interopRequireDefault(require("../components/ExportOrderModal.vue"));
var _excel = require("../excel");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    CustomerDialog: _CustomerDialog.default,
    DriverDialog: _DriverDialog.default,
    StoreDialog: _StoreDialog.default,
    DetailFoodModal: _DetailFoodModal.default,
    ExportOrderModal: _ExportOrderModal.default
  },
  props: {
    driverId: {
      type: Number,
      default: null
    },
    showStatusCol: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      totalRevenue: 0,
      totalIncome: 0,
      ORDER_FOOD_STATUS: _enum.ORDER_FOOD_STATUS,
      ORDER_ACTION: _enum.ORDER_ACTION,
      listLoading: false,
      total: 0,
      totalMoney: 0,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      listQuery: {
        page: 1,
        limit: 10,
        search: "",
        isBlock: null,
        status: null,
        fromMoneyProduct: null,
        toMoneyProduct: null
      },
      tableData: [],
      date: [(0, _moment.default)().subtract(7, "days").startOf("day").toDate(), (0, _moment.default)().endOf("days").endOf("day").toDate()],
      tagOptions: _enum.tagOptions,
      datePicker: {
        minDate: null,
        maxDate: null
      },
      pickerOptions: {
        disabledDate: this.disabledDueDate,
        onPick: this.handleChangeDatePicker
      },
      loadingExcel: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  created: function created() {
    if (!this.driverId) {
      this.getTableData();
    } else {
      this.getTableDataByDriverId();
    }
    this.$store.dispatch("area/fetchList");
  },
  watch: {
    driverId: function driverId() {
      this.getTableDataByDriverId();
    }
  },
  methods: {
    confirmExport: function confirmExport() {
      this.$refs["export-order-modal"].handleOpen(this.listQuery.page, this.listQuery.limit, this.date);
    },
    handleExportExcel: function () {
      var _handleExportExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(page, limit, from, to) {
        var query, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = {
                status: "COMPLETE",
                page: 1,
                limit: 500,
                fromDateTime: from,
                toDateTime: to,
                areaId: undefined
              };
              if (!!this.$store.state.user.info.area) {
                query.areaId = this.$store.state.user.info.area.id;
              }
              this.loadingExcel = true;
              _context.prev = 3;
              _context.next = 6;
              return (0, _excel.exportAllOrderApi)(order, query);
            case 6:
              data = _context.sent;
              if (data.length > 0) {
                (0, _excel.exportOrderExcel)({
                  orders: data,
                  type: _enum.ORDER_TYPE.FOOD
                });
                this.$message({
                  message: "\u0110\xE3 xu\u1EA5t ".concat(data.length, " \u0111\u01A1n h\xE0ng"),
                  type: "success"
                });
              } else {
                this.$message({
                  message: "Kh\xF4ng t\xECm th\u1EA5y \u0111\u01A1n h\xE0ng n\xE0o, Vui l\xF2ng ki\u1EC3m tra l\u1EA1i.",
                  type: "error"
                });
              }
            case 8:
              _context.prev = 8;
              this.loadingExcel = false;
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3,, 8, 11]]);
      }));
      function handleExportExcel(_x, _x2, _x3, _x4) {
        return _handleExportExcel.apply(this, arguments);
      }
      return handleExportExcel;
    }(),
    checkUserPermission: _permission.checkUserPermission,
    detailFood: function detailFood(order) {
      this.$refs["detail-food"].handleOpen(order);
    },
    viewStore: function viewStore(store) {
      this.$refs["store-dialog"].handleEdit(store);
    },
    viewCustomer: function viewCustomer(customer) {
      this.$refs["customer-dialog"].handleEdit(customer);
    },
    viewDriver: function viewDriver(driver) {
      this.$refs["driver-dialog"].handleEdit(driver);
    },
    disabledDueDate: function disabledDueDate(time) {
      if (this.datePicker.minDate) {
        var past60days = (0, _moment.default)(this.datePicker.minDate).subtract(60, "days").valueOf();
        var next60days = (0, _moment.default)(this.datePicker.minDate).add(60, "days").valueOf();
        return time.getTime() < past60days || time.getTime() > next60days;
      }
      return false;
    },
    handleChangeDatePicker: function handleChangeDatePicker(date) {
      this.datePicker = date;
    },
    getTableDataByDriverId: function getTableDataByDriverId() {
      var _this = this;
      driver.orderFood(this.driverId, this.listQuery).then(function (res) {
        _this.tableData = res.data.data;
        _this.total = res.data.total;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    formatNumberVN: function formatNumberVN(n) {
      return (0, _format.formatNumberVN)(n);
    },
    formatCurrency: function formatCurrency(n) {
      return (0, _format.formatCurrency)(n);
    },
    changeStatus: function changeStatus(select, row) {
      var _this2 = this;
      this.$confirm("B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n thay \u0111\u1ED5i tr\u1EA1ng th\xE1i th\xE0nh ".concat(_enum.ORDER_ACTION[select].toUpperCase()), "Cảnh báo", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Không",
        type: "warning"
      }).then(function () {
        _this2.listLoading = true;
        var data = {
          orderFood: {
            status: select
          }
        };
        order.update(row.id, data).then(function () {
          _this2.$notify({
            type: "success",
            message: "Thay đổi thành công"
          });
          _this2.getTableData();
        }).finally(function () {
          _this2.listLoading = false;
        });
      });
    },
    getTotalMoney: function getTotalMoney() {
      var _this3 = this;
      var listQuery = {
        from: this.listQuery.from,
        to: this.listQuery.to
      };
      var data = [];
      order.findAll(listQuery).then(function (res) {
        data = res.data.data;
        var total = 0;
        data.forEach(function (element) {
          if (element.status == "COMPLETE") total += element.moneyFinal - element.moneyIncome;
        });
        _this3.totalMoney = total;
      });
    },
    getSummary: function getSummary() {
      var _this4 = this;
      order.getSummary(this.listQuery).then(function (res) {
        _this4.totalRevenue = res.data.totalRevenue;
        _this4.totalIncome = res.data.totalIncome;
      });
    },
    getTableData: function getTableData() {
      var _this5 = this;
      if (this.listQuery.fromMoneyProduct && !this.listQuery.toMoneyProduct || !this.listQuery.fromMoneyProduct && this.listQuery.toMoneyProduct) {
        return this.$alert("Vui lòng điền đầy đủ giá tiền cao nhất và giá tiền thấp nhất.", "Lưu ý", {
          confirmButtonText: "OK"
        });
      }
      this.listLoading = true;
      this.listQuery.from = this.date ? this.date[0] : undefined;
      this.listQuery.to = this.date ? this.date[1] : undefined;
      this.getSummary();
      order.findAll(this.listQuery).then(function (res) {
        _this5.tableData = res.data.data;
        _this5.total = res.data.total;
      }).finally(function () {
        _this5.listLoading = false;
      });
    },
    formatDateTime: function formatDateTime(timestamp) {
      return (0, _date.formatDateTime)(timestamp);
    }
  }
};